import type { CatalogItem } from '@gorampe/catalog-adapter';

interface Props {
  item: CatalogItem;
  onClick: (item: CatalogItem) => void;
}

export function CatalogCard({ item, onClick }: Props) {
  const skuStr = item.sku as unknown as string;
  return (
    <button
      type="button"
      onClick={() => onClick(item)}
      className="group flex flex-col items-stretch rounded-lg border border-slate-200 bg-white p-3 text-left transition hover:border-blue-500 hover:shadow-md focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200"
    >
      <div className="aspect-square w-full overflow-hidden rounded bg-slate-50 flex items-center justify-center">
        {item.imageUrl ? (
          <img
            src={item.imageUrl}
            alt={skuStr}
            className="h-full w-full object-contain"
            loading="lazy"
          />
        ) : (
          <span className="font-mono text-xs text-slate-400">{skuStr}</span>
        )}
      </div>
      <div className="mt-2 flex flex-col gap-0.5">
        <div className="flex items-center justify-between gap-1">
          <span className="font-mono text-xs font-semibold text-slate-700">{skuStr}</span>
          <div className="flex flex-shrink-0 gap-1">
            <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] text-slate-600">
              {item.family}
            </span>
            {item.revision != null && (
              <span
                className="rounded bg-blue-100 px-1.5 py-0.5 text-[10px] text-blue-700"
                title={`Révision ${item.revision}`}
              >
                R{item.revision}
              </span>
            )}
          </div>
        </div>
        <span
          className="text-sm text-slate-800 leading-snug"
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {item.label}
        </span>
        {item.dimensionsLabel && (
          <span className="text-xs text-slate-500">{item.dimensionsLabel}</span>
        )}
        {item.weightLbs != null && (
          <span className="text-xs text-slate-500">{item.weightLbs.toFixed(1)} lbs</span>
        )}
        <span className="mt-1 text-sm font-semibold text-slate-900 font-mono">
          {item.priceCad > 0 ? `${item.priceCad.toFixed(2)} $` : '—'}
        </span>
      </div>
    </button>
  );
}
